export type FantasyInjuryStatus =
    | "injured"
    | "out"
    | null;

export interface FantasyInjuryInfo {
    status: FantasyInjuryStatus;
    label: string;
    description: string;
}

export function getFantasyInjuryInfo(
    injury?: string | number | null
): FantasyInjuryInfo {
    const value = String(injury ?? "").trim();

    if (value === "2") {
        return {
            status: "out",
            label: "Fuera",
            description:
                "Fuera por lesión para la próxima jornada."
        };
    }

    if (value === "1") {
        return {
            status: "injured",
            label: "Lesionado",
            description:
                "Lesionado o con participación incierta."
        };
    }

    return {
        status: null,
        label: "",
        description: ""
    };
}